<template>
	<div
		:ref="setup._map"
		class="map-holder"
		:style="{ backgroundImage: `url(${setup.backgroundUrl})`, backgroundSize: isCover ? 'cover' : ' contain' }"
		@click="setup.redirectToGoogleMap()">
		<div class="map-holder__overlay">{{ $t('common.shared.map.clickToEnlarge') }}</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedGoogleMapEmits, SharedGoogleMapProps } from './SharedGoogleMapSetup';
import SharedGoogleMapSetup from './SharedGoogleMapSetup';
const emits = defineEmits<SharedGoogleMapEmits>() as SharedGoogleMapEmits;
const props = withDefaults(defineProps<SharedGoogleMapProps>(), SharedGoogleMapSetup.defaultProps);
const setup = new SharedGoogleMapSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins.less";

.map-holder {
	cursor: pointer;
	position: relative;
	min-height: 3rem;
	background-repeat: no-repeat;
	background-position: center;

	&__overlay {
		.flex-align();

		position: absolute;
		inset: 0;
		padding: 1rem;
		font-size: 1.25rem;
		font-weight: 600;
		line-height: 1.1;
		color: white;
		text-align: center;
		opacity: 0;
		background-color: rgba(var(--rgb-grey-darker), 0.6);
		transition: opacity 0.3s;

		&:hover {
			opacity: 1;
		}
	}
}
</style>
